module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/019-ceuta-6b237639c7bad118fa6217b5b6115507.svg";